
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_16776_15149)"}},[_c('rect',{attrs:{"x":"14","y":"3","width":"16","height":"10","rx":"2","transform":"rotate(90 14 3)","fill":"#fff"}}),_c('rect',{attrs:{"x":"13.5","y":"3.5","width":"15","height":"9","rx":"1.5","transform":"rotate(90 13.5 3.5)","stroke":"#585858"}})]),_c('path',{attrs:{"stroke":"#585858","d":"M7.078 4.786h3.846"}}),_c('ellipse',{attrs:{"cx":"9","cy":"16.714","rx":".769","ry":".762","fill":"#585858"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_16776_15149","x":"0","y":"0","width":"18","height":"24","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_16776_15149"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_16776_15149","result":"shape"}})])])])
          )
        }
      }
    